import { requestMethodTypes } from '../Constants/api.constants';

const concurrencyRequest = (
    requestData = {},
) => {
    const method = requestMethodTypes.GET;

    const params = {
        form: 'json',
        schema: '1.0',
        _clientId: requestData.playerId,
        _encryptedLock: requestData.encryptedLock,
        _id: requestData.lockId,
        _sequenceToken: requestData.sequenceToken,
    };

    const request = {
        method,
        params,
    };

    return request;
};

export {
    concurrencyRequest as default,
};
